module.exports = __webpack_public_path__ + "img/cms.495e2636.png";